export default function MySQL_MICROSECOND() {
  return (
    <div>
      <h2>MySQL_MICROSECOND</h2>    </div>
  );
}